import { render, staticRenderFns } from "./AddEditPolicyContainer.vue?vue&type=template&id=49025850"
import script from "./AddEditPolicyContainer.vue?vue&type=script&lang=js"
export * from "./AddEditPolicyContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports